import { StripeError } from '@stripe/stripe-js';
import { Modal } from 'antd';
import { StripeProvider } from 'providers/StripeProvider';

import { SetupIntentPayment } from 'components/Payment/SetupIntentPayment/SetupIntentPayment';
import { useTranslation } from 'react-i18next';

interface AddPaymentMethodModalProps {
  open: boolean;
  onCancel: () => void;
  onSuccess?: () => void;
  onError?: (error: StripeError) => void;
  onSubmitStart?: () => void;
  loading?: boolean;
  title?: string;
}

export const AddPaymentMethodModal: React.FC<AddPaymentMethodModalProps> = ({
  open,
  onCancel,
  onSuccess,
  onError,
  onSubmitStart,
  loading,
  title
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      title={title ?? t('modal.addPaymentMethod.title')}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={600}
      destroyOnHidden
    >
      <StripeProvider>
        <SetupIntentPayment
          onSuccess={onSuccess}
          onError={onError}
          onSubmitStart={onSubmitStart}
          loading={loading}
        />
      </StripeProvider>
    </Modal>
  );
};
